export const REWIND_LOGO_HEADER_WIDTH = 66;
export const REWIND_LOGO_HEADER_HEIGHT = 44;

export const REWIND_LOGO_START_SCREEN_WIDTH = 436;
export const REWIND_LOGO_START_SCREEN_HEIGHT = 247;

export const REWIND_BRAND_DESIRE_HEIGHT = 37;
